import styled, {css} from 'styled-components';
import {
    DARK_MODE_COMMON_TEXT_COLOR,
    DARK_MODE_TABLE_BORDER,
    DARK_MODE_TEXT_COLOR
} from "../../../../constants/colorScheme";

const StyledContainer = styled.div` 
    ${props => props.darkMode && css` 
            .ant-list-bordered {
                border: ${DARK_MODE_TABLE_BORDER};                
            }
            .ant-list-split .ant-list-item {
                border-bottom: none;
            }
            .ant-list-split.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
                border-bottom: ${DARK_MODE_TABLE_BORDER};
            }
            .ant-list-item {
                color: ${DARK_MODE_COMMON_TEXT_COLOR};
                border: ${DARK_MODE_TABLE_BORDER};
            }        
            .ant-list-footer {
                color: ${DARK_MODE_TEXT_COLOR}
            }
        `
    }
`;

export default StyledContainer;